import React from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import ReactTable from 'react-table';
import SweetAlert from 'sweetalert2-react'
import i18n from "i18next";
import PageHeader from "../components/PageHeader";
import DataSource from '../util/DataSource';
import Spinner from "../components/Spinner";
import { val } from '../util/HelpfulFunctions';
import { filterContains, filterMatchSubstring } from "../util/GridHelpers";
import Metadata from '../util/MetadataManager';
import Dialog from '../components/Dialog';

class UserManagement extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            userData: '',
            errorMessage: '',
            caption: i18n.t("Χρήστες Portal")
        }
        
        this.errorNoResponseMessage = i18n.t("Η υπηρεσία δεν είναι διαθέσιμη αυτή τη στιγμή. Παρακαλώ επικοινωνήστε με την υποστήριξη πελατών");

        this.renderStdCell = this.renderStdCell.bind(this);
        this.renderActionsCell = this.renderActionsCell.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        return Object.assign(state, { caption: getCaption(props, state) });
    }

    render() {
        return (
            <div>
                {this.renderHeader()}
                {this.renderContent()}
                {this.renderMessage()}
            </div>
        )
    }

    renderHeader() {
        return (
            <PageHeader title={this.state.caption} />
        );
    }

    renderContent() {
        if (this.state.redirect) {
            return (<Redirect to={this.state.redirect} />);
        }
        else if (this.state.isBusy) {
            return (<Spinner />);
        }
        else if (this.state.userData) {

            return (
                <div className="row pt-3">
                    <div className="col">
                        {this.renderGrid()}
                    </div>
                </div>
            );
        }
    }

    renderGrid() {
        if (!this.state.metadata)
            return null;

        if (!this.state.userData || this.state.userData.length === 0) {
            return null;
        }

        const columns = [
            {
                accessor: "UserName",
                Header: this.state.metadata.Properties.find(p => p.Name === "UserName").Caption,
                headerClassName: "text-center",
                className: "text-center m-auto",
                Cell: this.renderStdCell,
                filterMethod: filterMatchSubstring
            },
            {
                accessor: "Description",
                Header: this.state.metadata.Properties.find(p => p.Name === "Description").Caption,
                headerClassName: "text-center",
                className: "text-center m-auto",
                Cell: this.renderStdCell,
                filterMethod: filterContains
            },
            {
                accessor: "eMail",
                Header: this.state.metadata.Properties.find(p => p.Name === "eMail").Caption,
                headerClassName: "text-center",
                className: "text-center m-auto",
                Cell: this.renderStdCell,
                filterMethod: filterMatchSubstring
            },
            {
                headerClassName: "text-center",
                className: "text-center m-auto",
                filterable: false,
                Cell: this.renderActionsCell
            }
        ];

        return (
            <div className="card p-10">
                <ReactTable 
                    data={this.state.userData}
                    pageText={i18n.t("Σελίδα")}
                    previousText={i18n.t("Προηγούμενη")}
                    nextText={i18n.t("Επόμενη")}
                    ofText={i18n.t("από")}
                    rowsText={i18n.t("γραμμές")}
                    noDataText={i18n.t("Δεν βρέθηκαν χρήστες")}
                    filterable={true}
                    minRows={0}
                    defaultPageSize ={Math.min(20, val(this.state.userData.length, 5))} 
                    columns={columns}
                    className="-striped -highlight"
                />
            </div>
        );
    }

    renderStdCell(cellInfo) {

        var user = this.state.userData[cellInfo.index];
        var className = (cellInfo.column.className ? cellInfo.column.className : "");
        if (!user.IsActive)
            className += " color-danger";

        return(
            <div
                className={className}
                contentEditable={false}
                suppressContentEditableWarning
            >
                <span className={className}>{cellInfo.value}</span>
            </div>
        );
    }

    renderActionsCell(cellInfo) {

        var className = '';
        var user = null;
        var command = null;
        var title;

        if (this.state.userData.length > 0) {
            user = this.state.userData[cellInfo.index];
        }

        className = cellInfo.column.className ? cellInfo.column.className : "";
        className += "mx-auto cmd-btn-outline-icon-normal";

        if (user.IsActive) {
            className = "cmd-btn-outline-icon-danger mdi mdi-lock";
            command = () => this.changeUserStatus(user, false);
            title = i18n.t("Απενεργοποίση λογαριασμού");
        }
        else {
            className = "cmd-btn-outline-icon-normal mdi mdi-lock-open";
            command = () => this.changeUserStatus(user, true);
            title = i18n.t("Ενεργοποίηση λογαριασμού");
        }

        return (
            <div>
                <button className={className}
                    name="button"
                    title={title}
                    onClick={command}>
                </button>
            </div>
        );
    }

    renderMessage() {
        var message, title, type, refresh;

        if (this.state.errorMessage) {
            title = i18n.t("Σφάλμα");
            message = this.state.errorMessage;
            type = "error";
            refresh = false;
        }
        else if (this.state.warningMessage) {
            title = i18n.t("Προσοχή!");
            message = this.state.warningMessage;
            type = "warning";
            refresh = false;
        }
        else if (this.state.infoMessage){
            message = this.state.infoMessage;
            type = "info";
            refresh = true;
        }

        return (
            <SweetAlert
                show={this.state.errorMessage || this.state.warningMessage || this.state.infoMessage}
                title={title}
                text={message}
                type={type}
                onConfirm={() => this.setState({errorMessage: null, warningMessage: null, infoMessage: null, refresh: refresh })} />
        );
    }

    componentDidMount() {
        this.getData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.match.params.status !== prevProps.match.params.status) {
            this.getData();
        }
    }

    async getData() {

        // avoid reentry
        if (this.state.isBusy)
            return;

        this.setState({ isBusy: true });

        try {

            if (!this.state.metadata) {
                var metadata = await Metadata.getEntity("User");
                this.setState({ metadata: metadata });
            }

            var filter = null;
            if (this.props.match.params.status) {
                if (this.props.match.params.status === "active") {
                    filter = "IsActive eq true";
                }
                else if (this.props.match.params.status === "inactive") {
                    filter = "IsActive eq false";
                }
                else if (this.props.match.params.status === "all") {
                    filter = "";
                }
            }

            //this.setState({ caption: getCaption(this.props, this.state) });

            var userData = await DataSource.query('User', {orderby: 'UserName', filter: filter});
            this.setState({ userData: userData});
        }
        catch (error) {
            console.log(error);
            this.setState({
                errorMessage: error.response ? error.response.data.Message : this.errorNotResponseMessage,
                userData: []
            });
        }
        finally {
            this.setState({isBusy: false});
        }
    }


    isUserAdmin() {
        var adminRole = JSON.parse(localStorage.getItem('userData'));

        if (adminRole && adminRole.hasOwnProperty('userRole') && adminRole.userRole === "admin") {
            return true;
        }
    }

    async changeUserStatus(_user, _newStatus) {
        try {

            var title;
            var message;

            if (_newStatus) {
                title = i18n.t("Ενεργοποίηση λογαριασμού");
                message = i18n.t("Ο λογαριασμός του χρήστη είναι ανενεργός. Θέλετε σίγουρα να τον ενεργοποιήσετε;");
            }
            else {
                title = i18n.t("Απενεργοποίηση λογαριασμού");
                message = i18n.t("Θέλετε σίγουρα να απενεργοποιήσετε τον λογαριασμό;");
            }
                
            var response = await Dialog.displayYesNoQuestion({ title: title, message: message});

            if (response) {
                _user.IsActive = _newStatus;
                var response = await DataSource.persist("User", _user);
                
                await this.getData();
            }
        }
        catch (error) {
            this.setState({
                errorMessage: error.response ? error.response.data.Message : this.errorNoResponseMessage, infoMessage: null
            });
        }
    }

}

function getCaption(props, state) {
    var caption = state.caption;

    if (props.match.params.status) {
        if (props.match.params.status === "active") {
            caption = i18n.t("Ενεργοί χρήστες");
        }
        else if (props.match.params.status === "inactive") {
            caption = i18n.t("Ανενεργοί χρήστες");
        }
        else if (props.match.params.status === "all") {
            caption = i18n.t("Χρήστες Portal");
        }
    }
    else if (props.match.path && props.match.path === "/adminUsers/all") {
        caption = caption = i18n.t("Χρήστες Portal");
    }

    return caption;
}


export default withRouter(UserManagement);